export default __webpack_public_path__ + "static/media/LTC.81e37586.svg";